import { useMemo } from 'react';
import { useWorkflowModel } from '../workflow.model';
import type { WorkflowWebhookTriggerEditModel } from '../workflow-node-models/workflow-webhook-trigger-edit.model';

export function useWorkflowWebhookTriggerEditModel(params: {
  triggerId: string;
  isDraftOnly: boolean;
}): WorkflowWebhookTriggerEditModel {
  const workflowModel = useWorkflowModel();
  return useMemo(
    () =>
      workflowModel.getWebhookTriggerEditModel({
        triggerId: params.triggerId,
        isDraftOnly: params.isDraftOnly,
      }),
    [workflowModel, params.triggerId, params.isDraftOnly]
  );
}
